( function( app ) {
  const COMPONENT = {
    init: function() {
    },
    finalize: function() {
      if ( $( window ).width() > 768 ) {
        // easy-toggle-state binds its click handlers in its own DOMContentLoaded
        // listener, which can fire after this one — force (re)init so the
        // handlers exist before we trigger the click below
        if ( typeof window.easyToggleState === 'function' ) {
          window.easyToggleState();
        }

        // on desktop, open the first menu on each dropdown panel
        $( '.navigation-four .primary-menu-first__default-open' ).trigger( 'click' );

        // ADA close menu when focus shifts outside of it
        $( '.navigation-four .primary-navigation__panels' ).on( 'focusout', function( e ) {
          const $menuItem = $( this );
          console.log( $menuItem );
          const newFocus = e.relatedTarget;
          if ( newFocus === null ) return;
          if ( !$menuItem.has( newFocus ).length ) {
            const $trigger = $menuItem.find( '.primary-menu-item__link.is-open' );
            if ( $trigger.length ) {
              $trigger.trigger( 'click' );
              newFocus.focus();
            }
          }
        } );
      }
    },
  };

  app.registerComponent( 'navigation-four', COMPONENT );
} )( app );
